const loading = (display) => {
  const loading = document.querySelector("#loading");
  loading.style.display = display;
};

export default loading;
